export default function HidableElement(target) {
  this.show = () => {
    target.style.display = null;
  };
  this.hide = () => {
    target.style.display = 'none';
  };
  this.showIff = (shouldShow) => (shouldShow ? this.show() : this.hide());
  this.hideIff = (shouldHide) => this.showIff(!shouldHide);
}
